<template>
    <Slide left>
        <router-link :to="{ name: 'home' }" tag="a" aria-label="Ga naar de beginpagina"><span><font-awesome-icon icon="home"></font-awesome-icon></span></router-link>
        <router-link :to="{ name: 'security' }" tag="a" aria-label="Beveiliging"><span>Beveiliging</span></router-link>
        <router-link to="#" tag="a" aria-label="Technologische Beveiliging"><span>Technologie</span></router-link>
        <router-link to="#" tag="a" aria-label="Analytics"><span>Analytics</span></router-link>
        <router-link :to="{ name: 'work'}" tag="a" aria-label="Werken bij Rijnland Beveiliging."><span>Werken bij ons</span></router-link>
        <router-link :to="{ name: 'partners'}" tag="a" aria-label="Maak kennis met onze partners."><span>Partners</span></router-link>
        <router-link :to="{ name: 'contact'}" tag="a" aria-label="Neem contact met ons op."><span>Contact</span></router-link>
    </Slide>
</template>

<script>
import { Slide } from 'vue-burger-menu';

export default {
    components: {
        Slide
    }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles.scss";


/deep/ {
 .bm-burger-button {
      position: fixed;
      width: 36px;
      height: 30px;
      left: 36px;
      top: 36px;
      cursor: pointer;
      z-index: 9999;
    }
    .bm-burger-bars {
      background-color: $lightColor;
    }
    .line-style {
      position: absolute;
      height: 20%;
      left: 0;
      right: 0;
    }
    .cross-style {
      position: absolute;
      top: 12px;
      right: 2px;
      cursor: pointer;
    }
    .bm-cross {
      background: #bdc3c7;
    }
    .bm-cross-button {
      height: 24px;
      width: 24px;
    }
    .bm-menu {
      height: 100%; /* 100% Full-height */
      width: 0; /* 0 width - change this with JavaScript */
      position: fixed; /* Stay in place */
      z-index: 1000; /* Stay on top */
      top: 0;
      left: 0;
      background-color:$lightColor; /* Black*/
      overflow-x: hidden; /* Disable horizontal scroll */
      padding-top: 60px; /* Place content 60px from the top */
      transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
    }

    .bm-overlay {
      background: rgba(0, 0, 0, 0.3);
    }
    .bm-item-list {
      color: $darkColor;
      margin-left: 10%;
      font-size: 20px;
    }
    .bm-item-list > * {
      display: flex;
      text-decoration: none;
      padding: 0.7em;
    }
    .bm-item-list > * > span {
      margin-left: 10px;
      font-weight: 700;
      color: $darkColor;
    }
}
</style>